module.exports = __webpack_public_path__ + "img/kairan.e41e9e17.jpg";